//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { categoryApi, getCompanyLists, syncProduct, deleteAndSyncProduct } from '@/api/store';
import * as orderListApi from '@/api/orderListApi';
export default {
  components: {},
  data: function data() {
    return {
      constants: this.$constants,
      listPram: {
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      TYPE_MAP: [{
        name: '自营商品',
        value: 1
      }, {
        name: '福司令商品',
        value: 2
      }, {
        name: '蛋糕商品',
        value: 3
      }],
      listData: {
        list: [],
        total: 0
      },
      listLoading: true,
      showCateIdOption: [],
      customersLists: []
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.handlerGetListData(this.listPram);
    this.getCustomers();
    this.getCategorySelect();
  },
  methods: {
    handerSearch: function handerSearch() {
      this.listPram.page = 1;
      this.handlerGetListData(this.listPram);
    },
    handlerGetListData: function handlerGetListData() {
      var _this = this;
      var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.listLoading = true;
      getCompanyLists(pram).then(function (data) {
        _this.listData = data;
        _this.listLoading = false;
      }).catch(function (err) {
        _this.listLoading = false;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData(this.listPram);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData(this.listPram);
    },
    getCategorySelect: function getCategorySelect() {
      var _this2 = this;
      this.showCateIdOption = [];
      categoryApi({
        status: -1,
        type: 8
      }).then(function (res) {
        _this2.showCateIdOption = res;
      });
    },
    getCustomers: function getCustomers() {
      var _this3 = this;
      this.customersLists = [];
      orderListApi.activeCustomersApi().then(function (res) {
        _this3.customersLists = res;
      });
    },
    sendSyncProduct: function sendSyncProduct() {
      var _this4 = this;
      deleteAndSyncProduct({
        isSync: 1
      }).then(function (res) {
        _this4.$message.success('操作成功！');
        _this4.listPram.page = 1;
        _this4.handlerGetListData(_this4.listPram);
      });
    }
  }
};